<script setup lang="ts">
import { ref, reactive } from "vue";
import { __color } from "@zyzgroup/core-web";
import Box from "../base/Box.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    color?: string;
    dur?: number;
  }>(),
  {
    color: "#3cefff",
    dur: 750
  }
);

// const emits = defineEmits<{
//   (event: "click"): void;
// }>();

const style = reactive<Record<string, string>>({
  transition: `box-shadow ${props.dur}ms`,
  borderRadius: "100%"
});

const resize = (box) => {
  style.width = style.height =
    Math.ceil(Math.max(box.rect.width, box.rect.height)) + "px";
  start();
};

const start = () => {
  const c = __color.set(props.color).setAlpha(0.2).toString();
  style.boxShadow = `
    inset ${style.width} 0 0 ${c},
    inset 0 ${style.width} 0 ${c},
    inset -${style.width} 0 0 ${c},
    inset 0 -${style.width} 0 ${c}
  `;
};

const end = () => {
  style.boxShadow = `
    inset 0.5em 0 0 rgba(255, 0, 0, 0.5),
    inset 0 0.5em 0 rgba(252, 150, 0, 0.5),
    inset -0.5em 0 0 rgba(0, 255, 0, 0.5),
    inset 0 -0.5em 0 rgba(0, 150, 255, 0.5)
  `;
};

defineExpose({ start, end });
</script>

<template>
  <Box
    class="circle"
    display="shrink"
    @resize="resize"
  >
    <div
      class="circle-before"
      :style="style"
    ></div>
    <div class="circle-inner">
      <slot></slot>
    </div>
  </Box>
</template>

<style scoped>
.circle-before {
  position: absolute;
  z-index: 2;
}
.circle-inner {
  position: relative;
  z-index: 1;
  cursor: pointer;
}
</style>
